import type { ReactNode } from 'react';

export const symbol_nest_multi_room: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-180h310v-145H220v145Zm370 0h150v-145H590v145ZM220-385h150v-145H220v145Zm210 0h310v-145H430v145ZM247-590h466L480-763 247-590Zm-27 470q-24.75 0-42.37-17.63Q160-155.25 160-180v-390q0-14.25 6.38-27 6.37-12.75 17.62-21l260-195q8.3-6 17.34-9 9.05-3 18.86-3 9.8 0 18.71 3 8.92 3 17.09 9l260 195q11.25 8.25 17.63 21 6.37 12.75 6.37 27v390q0 24.75-17.62 42.37Q764.75-120 740-120H220Z"
		/>
	</svg>
);
